export default function SectionTitle({ eyebrow, title, subtitle, center = false }) {
  return (
    <div className={center ? "text-center" : ""}>
      {eyebrow && (
        <div className="mb-2 inline-block rounded-full border border-white/10 px-3 py-1 text-xs uppercase tracking-wider text-gray-600 dark:text-gray-300">
          {eyebrow}
        </div>
      )}
      <h2 className="font-display text-3xl sm:text-4xl md:text-5xl tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-3 max-w-2xl text-gray-600 dark:text-gray-300 mx-auto">
          {subtitle}
        </p>
      )}
    </div>
  );
}